import { apiClient } from '@melio/javascript-sdk';

const client = apiClient.paymentsReport();
const createReport: typeof client.createReport = (params) => client.createReport(params);
export const usePaymentsReport = () => ({ createReport });
